import { PROGRESS_NUMBER_LIST } from "../../../../Data/UiKit/Progress/index";

export const DynamicProgressWithNumberSteps = () => {
  return (
    <>
      {PROGRESS_NUMBER_LIST.map(({ color, number, className }, index) => (
        <button
          className={`position-absolute btn-primary btn-sm top-0 ${className} translate-middle rounded-circle`}
          type="button"
          style={{
            width: "2rem",
            height: "2rem",
          }}
          key={index}>
          {number}
        </button>
      ))}
    </>
  );
};
